// Auto-generated by scripts/generate-env.cjs — do not edit. Values from Passport/.env (and process.env).
export const VITE_API_URL = "https://staging-api.tranzit.io";
export const VITE_FIREBASE_API_KEY = "AIzaSyDMYEuWdpzkjbCTF6gz8slV_xYLNc68mEc";
export const VITE_FIREBASE_AUTH_DOMAIN = "tranzit-staging.firebaseapp.com";
export const VITE_FIREBASE_PROJECT_ID = "tranzit-staging";
export const VITE_FIREBASE_STORAGE_BUCKET = "tranzit-staging.firebasestorage.app";
export const VITE_FIREBASE_MESSAGING_SENDER_ID = "1003943649506";
export const VITE_FIREBASE_APP_ID = "1:1003943649506:web:6163ee18bff113aa94febb";
export const VITE_FIREBASE_API_KEY_SECONDARY = "";
export const VITE_FIREBASE_AUTH_DOMAIN_SECONDARY = "";
export const VITE_FIREBASE_PROJECT_ID_SECONDARY = "";
export const VITE_FIREBASE_STORAGE_BUCKET_SECONDARY = "";
export const VITE_FIREBASE_MESSAGING_SENDER_ID_SECONDARY = "";
export const VITE_FIREBASE_APP_ID_SECONDARY = "";
export const VITE_PASSPORT_TURNSTILE_SITE_KEY = "0x4AAAAAADVfFUilHWGHbd10";
export const VITE_VVID_MAX_FILE_BYTES = 5242880;
export const VITE_VVID_STORAGE_PATH_PREFIX = "carrierPassports/";
export const VITE_PASSPORT_DOCUMENT_PACKAGE_ENABLED = "true";
export const VITE_PASSPORT_DOCUMENT_PACKAGE_EXTERNAL_EMAIL = "true";
export const VITE_PASSPORT_FLEET_ORG_ENABLED = "true";
export const VITE_PASSPORT_CMV_ENABLED = "true";
export const VITE_PASSPORT_OUTSIDE_NETWORK_INVITE_ENABLED = "true";
export const VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY = "6LeRoBAtAAAAAL7bDo09l_sZxnyEO1fjW71XGXvN";
export const VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN = "";